<script setup lang="ts">
const isOpen = ref(false);

const route = useRoute();
watch(() => route.fullPath, () => {
  isOpen.value = false;
});
</script>

<template>
  <USlideover
    v-model:open="isOpen"
    side="left"
    :ui="{
      content: 'max-w-sm bg-(--color-sidebar-bg)',
      overlay: 'bg-black/25',
      header: 'min-h-0 border-0 px-3 py-2 sm:px-3',
      body: 'p-0 sm:p-0',
      title: 'sr-only',
    }"
    title="Navigation menu"
  >
    <button
      type="button"
      aria-label="Open menu"
      class="inline-flex shrink-0"
    >
      <UiFaIcon :icon="['fal', 'bars']" class="text-2xl text-(--ui-primary)" />
    </button>
    <template #body>
      <LayoutSidebar class="p-5 min-h-0" />
    </template>
  </USlideover>
</template>
